import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormControl, FormGroup, FormGroupDirective } from "@angular/forms";

@Component({
  selector: "app-text-area",
  templateUrl: "./text-area.component.html",
  styleUrls: ["./text-area.component.scss"],
})
export class TextAreaComponent implements OnInit {
  @Input() controller: string;
  @Input() data: string;
  @Input() label: string = "Input Field";
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Input() edit: boolean = true;
  public html = "";
  public areaData = "";
  form: FormGroup;
  constructor(private parent: FormGroupDirective) {}

  ngOnInit(): void {
    this.form = this.parent.form;

    if (this.form) {
      this.form.addControl(this.controller, new FormControl(this.data || ""));
    }
    setTimeout(() => {
      this.html = this.data;
    }, 1000);
  }

  changeEvent(e: any) {
    this.change.emit(e.target.innerHTML);
  }
}
